export const AGE_GROUP_OPTIONS = Object.freeze([
  { value: "under_13", label: "Under 13 år" },
  { value: "13_15", label: "13-15 år" },
  { value: "16_17", label: "16-17 år" },
  { value: "18_24", label: "18-24 år" },
  { value: "25_34", label: "25-34 år" },
  { value: "35_44", label: "35-44 år" },
  { value: "45_54", label: "45-54 år" },
  { value: "55_64", label: "55-64 år" },
  { value: "65_plus", label: "65 år eller äldre" },
]);

const AGE_GROUP_LABELS = Object.freeze({
  ...Object.fromEntries(AGE_GROUP_OPTIONS.map(({ value, label }) => [value, label])),
  // Existing adult accounts keep their valid legacy classification until changed.
  "18_plus": "18 år eller äldre",
});

export function getAgeGroupLabel(value) {
  return AGE_GROUP_LABELS[value] || "Inte bekräftad";
}
